module.exports = __webpack_public_path__ + "media/images/about-us-bc08cda349c680f8d0bc4bb57c754c84.jpg";